import { buildDocsUrl, canOpenDocsPlugin } from "./docs.contract";
import { TRUCKING_DICTIONARY_PATH } from "./trucking-dictionary";

/**
 * Build canonical in-app help deep links.
 */
export function buildHelpFeaturesPath(helpSectionId) {
  const normalizedId = String(helpSectionId || "").trim();
  if (!normalizedId) return "/help/features";
  return `/help/features#${normalizedId}`;
}

/**
 * In-app path for a help registry item.
 * Page-style guides (dictionary) navigate to their own route instead of a hash.
 * @param {{ helpKind?: string, inAppPath?: string, helpSectionId?: string, id?: string }} [item]
 * @returns {string}
 */
export function getFeatureHelpPath(item) {
  if (item?.helpKind === "page" && item.inAppPath) {
    return item.inAppPath;
  }
  return buildHelpFeaturesPath(item?.helpSectionId || item?.id);
}

/**
 * Published docs URL for a help registry item.
 * Pass `user` to hide developer / proposals / plans links from non-superAdmins.
 * @param {{ docsPluginId?: string, docsSlug?: string }} [item]
 * @param {{ authority?: string }|null|undefined} [user]
 * @returns {string|null}
 */
export function getDocsUrl(item, user) {
  if (user !== undefined && !canOpenDocsPlugin(item?.docsPluginId, user)) {
    return null;
  }
  return buildDocsUrl({
    docsPluginId: item?.docsPluginId,
    docsSlug: item?.docsSlug,
  });
}

/**
 * Whether a help card matches a user search (title, description, keywords, terms).
 * @param {object} item
 * @param {string} [query]
 * @returns {boolean}
 */
export function matchesHelpQuery(item, query) {
  const search = String(query || "")
    .toLowerCase()
    .trim();
  if (!search) return true;
  const haystack = [
    item?.title,
    item?.description,
    item?.id,
    item?.overview,
    ...(item?.searchKeywords || []),
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
  return haystack.includes(search);
}

export const HELP_DICTIONARY_PATH = TRUCKING_DICTIONARY_PATH;

